import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './button-base2.js';

const NlButton = /*@__PURE__*/ proxyCustomElement(class NlButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.theme = 'default';
        this.darkMode = false;
        this.titleBtn = 'Open modal';
        this.disabled = false;
    }
    render() {
        return h("button-base", { key: '9f7936090efc7263cce71d1ad89490d7f5445991', theme: this.theme, darkMode: this.darkMode, titleBtn: this.titleBtn, disabled: this.disabled });
    }
}, [1, "nl-button", {
        "theme": [1],
        "darkMode": [4, "dark-mode"],
        "titleBtn": [1, "title-btn"],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["nl-button", "button-base"];
    components.forEach(tagName => { switch (tagName) {
        case "nl-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NlButton);
            }
            break;
        case "button-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NlButton as N, defineCustomElement as d };

//# sourceMappingURL=nl-button2.js.map